var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { SvgIcon } from "@material-ui/core";
const SvgSort = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 12.85 12.85"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.06,2.65A1.09,1.09,0,0,0,0,3.73,1.12,1.12,0,0,0,.3,4.5L5.65,9.84a1.07,1.07,0,0,0,1.52,0h0l5.35-5.35a1.07,1.07,0,0,0,0-1.52,1.11,1.11,0,0,0-.76-.32Z"
})));
export default SvgSort;